import React from "react";
import { useInvoicePDF, InvoicePDFFrame } from "./InvoicePDF2";
import { useLocation } from "react-router-dom";

const InvoicePDFViewerPage = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id");
  const invoicePdf = useInvoicePDF(id);

  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        position: "absolute",
        top: 0,
        left: 0,
        zIndex: 9999,
        background: "white",
      }}
    >
      <InvoicePDFFrame
        url={invoicePdf.url}
        error={invoicePdf.error}
        height="100vh"
      />
    </div>
  );
};

export default InvoicePDFViewerPage;
